import { Debit } from "src/shared/models/debit.model";

export const DebitSerializer = {
  fromJson(json: any): Debit {
    return new Debit(json);
  },

  fromJsonList(json: any[]): Debit[] {
    return json.map((item) => new Debit(item));
  },
};
